var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 19,
    fill: "#E84288",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2969 27V24.5625L18.9922 19.2891C19.4766 18.8203 19.8828 18.3984 20.2109 18.0234C20.5443 17.6484 20.7969 17.2812 20.9688 16.9219C21.1406 16.5573 21.2266 16.1641 21.2266 15.7422C21.2266 15.2734 21.1198 14.8698 20.9063 14.5312C20.6927 14.1875 20.401 13.9245 20.0313 13.7422C19.6615 13.5547 19.2422 13.4609 18.7734 13.4609C18.2839 13.4609 17.8568 13.5599 17.4922 13.7578C17.1276 13.9557 16.8464 14.2396 16.6484 14.6094C16.4505 14.9792 16.3516 15.4193 16.3516 15.9297H13.1406C13.1406 14.8828 13.3776 13.974 13.8516 13.2031C14.3255 12.4323 14.9896 11.8359 15.8438 11.4141C16.6979 10.9922 17.6823 10.7812 18.7969 10.7812C19.9427 10.7812 20.9401 10.9844 21.7891 11.3906C22.6432 11.7917 23.3073 12.349 23.7813 13.0625C24.2552 13.776 24.4922 14.5937 24.4922 15.5156C24.4922 16.1198 24.3724 16.7161 24.1328 17.3047C23.8984 17.8932 23.4792 18.5469 22.875 19.2656C22.2708 19.9792 21.4193 20.8359 20.3203 21.8359L17.9844 24.125V24.2344H24.7031V27H13.2969Z",
    fill: "#E84288"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwo);
export default __webpack_public_path__ + "static/media/two.84044888ff94a15b3cd7eaae0d0e6465.svg";
export { ForwardRef as ReactComponent };